import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";

import { IconSearch, IconX} from '@tabler/icons-react';

export default function SearchTextField({
  value,
  setValue,
  label = "Search",
  placeholder = "",
  variant = "outlined",
  size="small",
  ...props
}) {
  return (
    <TextField
      {...props}
      label={label}
      placeholder={placeholder}
      size={size}
      value={value}
      variant={variant}
      fullWidth
      onChange={(event) => {
        setValue(event.target.value);
      }}
      slotProps={{
        input: {
          endAdornment: value ? 
          (
            <InputAdornment position="end">
              <IconButton
                onClick={()=>setValue("")}
                edge="end"
              >
                <IconX color="#717272"/>
              </IconButton>
            </InputAdornment>
          )
          :
          (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                disabled
              >
                <IconSearch color="#717272" />
              </IconButton>
            </InputAdornment>
          )
          ,
        },
        inputLabel: {
          shrink: true,
        },
      }}
    />
  );
}
